package com.essntl.core.settings.ui

import com.essntl.core.settings.domain.model.configuration.ConfigurationCurrencyModel
import com.essntl.core.utils.viewmodel.State

data class AllowedCurrenciesState(
    val getAllowedCurrencies: State<ConfigurationCurrencyModel?> = State(),
    val deleteLoading: List<String> = emptyList(),
    val updateLoading: List<String> = emptyList(),
)
